module.exports = __webpack_public_path__ + "img/bt.2dc16de1.png";